<template>
  <span
    v-if="visible"
    :class="`provider-badge provider-badge--${label}`"
  >
    {{ label }}
  </span>
</template>

<script>
export default {
  name: "provider-badge",
  props: {
    flight_offer: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    label() {
      const { _provider = "" } = this.flight_offer || {};
      return _provider || "—";
    },
    visible() {
      return this.show_developer_tools() && !!this.label;
    },
  },
};
</script>

<style lang="scss" scoped>
.provider-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;
  background: #333;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  font-weight: 600;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);

  &--amadeus {
    background: #b3dcff;
    color: #0b3d66;
  }
  &--kyte {
    background: #dcc3ff;
    color: #3f1d80;
  }
  &--travelfusion {
    background: #fff3b0; // light yellow
    color: #6b5400;
  }
  &--sabre {
    background: #ffc9c9; // light red
    color: #7a0b0b;
  }
}
</style>
